import { render, staticRenderFns } from "./SignUpPanel.vue?vue&type=template&id=5f90e177&scoped=true&"
import script from "./SignUpPanel.vue?vue&type=script&lang=js&"
export * from "./SignUpPanel.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPanel.vue?vue&type=style&index=0&id=5f90e177&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90e177",
  null
  
)

export default component.exports